import { render, staticRenderFns } from "./GraficaIncidentes.vue?vue&type=template&id=335335c5"
import script from "./GraficaIncidentes.vue?vue&type=script&lang=js"
export * from "./GraficaIncidentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports